import React, { useState, useEffect } from 'react';

import { FeatureSource, ModelBase } from "@models";
import { 
  FightingStyle, 
} from "@dndModels";

import API from "@utilities/smart_api";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

const api = API.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function FightingStyleEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<FightingStyle>(param_obj instanceof FightingStyle ? param_obj : api.applyWorkingOn(new FightingStyle()));
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  return (
    <FeatureSourceInput 
      obj={obj}
      data_type="fighting_style"
      disabled={disabled}
      change_time={0}
      onChange={(changed: FeatureSource) => {
        if (changed instanceof FightingStyle) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
        }
      }}
    >
    </FeatureSourceInput>
  ); 
}
